var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Typography } from '@mui/material';
import { useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import { campaignCheckedState } from '../../recoil/campaignCheckedState';
var NewRoasterCampaignLabel = function (props) {
    var t = useTranslation().t;
    var setCampaignChecked = useSetRecoilState(campaignCheckedState);
    var isPassedCampaignPeriod = React.useMemo(function () {
        var endDateTime = new Date('2022-12-31T15:00:00.000Z'); //campaign終了の日時(日本時間2023年1月1日0時))
        var currentDateTime = new Date();
        return endDateTime < currentDateTime;
    }, []);
    if (isPassedCampaignPeriod)
        return null;
    return (React.createElement(Typography, __assign({ onClick: function () { return setCampaignChecked(true); }, variant: "caption" }, props), t('labels.newRoasterCampaignUnderway')));
};
export default NewRoasterCampaignLabel;
